import React, { useEffect } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import {
  ElementAttribute,
  ElementCard,
} from '../components/ElementCard/ElementCard';
import { Box } from '@mui/material';
import ElementCardGroup from '../components/ElementCard/ElementCardGroup';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

export const Projects: React.FC = () => {
  const { theme, setThemes } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);

  let turnOfLeft = false;

  const getTurn = () => {
    turnOfLeft = !turnOfLeft;
    return turnOfLeft;
  };

  useEffect(() => {
    setThemes(['pages', 'elementcards']);
  }, []);

  const attributesList1: ElementAttribute[] = [
    {
      name: t('projects/walletmaster/description/tag'),
      content: t('projects/walletmaster/description/desc'),
    },
    {
      name: t('projects/walletmaster/techs/tag'),
      content: t('projects/walletmaster/techs/desc'),
    },
    {
      name: t('projects/walletmaster/link/tag'),
      content: t('projects/walletmaster/link/desc'),
      ref: t('projects/walletmaster/link/ref'),
      href: t('projects/walletmaster/link/href'),
    },
    {
      name: t('projects/walletmaster/try/tag'),
      content: t('projects/walletmaster/try/desc'),
      ref: t('projects/walletmaster/try/ref'),
      href: t('projects/walletmaster/try/href'),
    },
    {
      name: t('projects/walletmaster/showcase/tag'),
      content: t('projects/walletmaster/showcase/desc'),
      ref: t('projects/walletmaster/showcase/ref'),
      href: t('projects/walletmaster/showcase/href'),
    },
  ];
  const attributesList2: ElementAttribute[] = [
    {
      name: t('projects/tfg/description/tag'),
      content: t('projects/tfg/description/desc'),
    },
    {
      name: t('projects/tfg/techs/tag'),
      content: t('projects/tfg/techs/desc'),
    },
    {
      name: t('projects/tfg/link/tag'),
      content: t('projects/tfg/link/desc'),
      ref: t('projects/tfg/link/ref'),
      href: t('projects/tfg/link/href'),
    },
    {
      name: t('projects/tfg/showcase/tag'),
      content: t('projects/tfg/showcase/desc'),
      ref: t('projects/tfg/showcase/ref'),
      href: t('projects/tfg/showcase/href'),
    },
  ];
  const attributesList3: ElementAttribute[] = [
    {
      name: t('projects/tfm/description/tag'),
      content: t('projects/tfm/description/desc'),
    },
    {
      name: t('projects/tfm/techs/tag'),
      content: t('projects/tfm/techs/desc'),
    },
    {
      name: t('projects/tfm/link/tag'),
      content: t('projects/tfm/link/desc'),
      ref: t('projects/tfm/link/ref'),
      href: t('projects/tfm/link/href'),
    },
    {
      name: t('projects/tfm/showcase/tag'),
      content: t('projects/tfm/showcase/desc'),
      ref: t('projects/tfm/showcase/ref'),
      href: t('projects/tfm/showcase/href'),
    },
  ];
  const attributesList4: ElementAttribute[] = [
    {
      name: t('projects/kustom/description/tag'),
      content: t('projects/kustom/description/desc'),
    },
    {
      name: t('projects/kustom/techs/tag'),
      content: t('projects/kustom/techs/desc'),
    },
    {
      name: t('projects/kustom/link/tag'),
      content: t('projects/kustom/link/desc'),
      ref: t('projects/kustom/link/ref'),
      href: t('projects/kustom/link/href'),
    },
    {
      name: t('projects/kustom/linkdrive/tag'),
      content: t('projects/kustom/linkdrive/desc'),
      ref: t('projects/kustom/linkdrive/ref'),
      href: t('projects/kustom/linkdrive/href'),
    },
  ];
  const attributesList5: ElementAttribute[] = [
    {
      name: t('projects/fons/description/tag'),
      content: t('projects/fons/description/desc'),
    },
    {
      name: t('projects/fons/techs/tag'),
      content: t('projects/fons/techs/desc'),
    },
    {
      name: t('projects/fons/link/tag'),
      content: t('projects/fons/link/desc'),
      ref: t('projects/fons/link/ref'),
      href: t('projects/fons/link/href'),
    },
    {
      name: t('projects/fons/showcase/tag'),
      content: t('projects/fons/showcase/desc'),
      ref: t('projects/fons/showcase/ref'),
      href: t('projects/fons/showcase/href'),
    },
  ];
  const attributesList6: ElementAttribute[] = [
    {
      name: t('projects/xcelsona/description/tag'),
      content: t('projects/xcelsona/description/desc'),
    },
    {
      name: t('projects/xcelsona/techs/tag'),
      content: t('projects/xcelsona/techs/desc'),
    },
    {
      name: t('projects/xcelsona/link/tag'),
      content: t('projects/xcelsona/link/desc'),
      ref: t('projects/xcelsona/link/ref'),
      href: t('projects/xcelsona/link/href'),
    },
    {
      name: t('projects/xcelsona/showcase/tag'),
      content: t('projects/xcelsona/showcase/desc'),
      ref: t('projects/xcelsona/showcase/ref'),
      href: t('projects/xcelsona/showcase/href'),
    },
  ];
  const attributesList7: ElementAttribute[] = [
    {
      name: t('projects/oxo/description/tag'),
      content: t('projects/oxo/description/desc'),
    },
    {
      name: t('projects/oxo/techs/tag'),
      content: t('projects/oxo/techs/desc'),
    },
    {
      name: t('projects/oxo/link/tag'),
      content: t('projects/oxo/link/desc'),
      ref: t('projects/oxo/link/ref'),
      href: t('projects/oxo/link/href'),
    },
    {
      name: t('projects/oxo/showcase/tag'),
      content: t('projects/oxo/showcase/desc'),
      ref: t('projects/oxo/showcase/ref'),
      href: t('projects/oxo/showcase/href'),
    },
  ];
  const attributesList8: ElementAttribute[] = [
    {
      name: t('projects/snakemrv/description/tag'),
      content: t('projects/snakemrv/description/desc'),
    },
    {
      name: t('projects/snakemrv/techs/tag'),
      content: t('projects/snakemrv/techs/desc'),
    },
    {
      name: t('projects/snakemrv/link/tag'),
      content: t('projects/snakemrv/link/desc'),
      ref: t('projects/snakemrv/link/ref'),
      href: t('projects/snakemrv/link/href'),
    },
  ];
  const attributesList9: ElementAttribute[] = [
    {
      name: t('projects/cserg/description/tag'),
      content: t('projects/cserg/description/desc'),
    },
    {
      name: t('projects/cserg/techs/tag'),
      content: t('projects/cserg/techs/desc'),
    },
    {
      name: t('projects/cserg/link/tag'),
      content: t('projects/cserg/link/desc'),
      ref: t('projects/cserg/link/ref'),
      href: t('projects/cserg/link/href'),
    },
  ];
  const attributesList10: ElementAttribute[] = [
    {
      name: t('projects/mkmudae/description/tag'),
      content: t('projects/mkmudae/description/desc'),
    },
    {
      name: t('projects/mkmudae/techs/tag'),
      content: t('projects/mkmudae/techs/desc'),
    },
    {
      name: t('projects/mkmudae/link/tag'),
      content: t('projects/mkmudae/link/desc'),
      ref: t('projects/mkmudae/link/ref'),
      href: t('projects/mkmudae/link/href'),
    },
    {
      name: t('projects/mkmudae/try/tag'),
      content: t('projects/mkmudae/try/desc'),
      ref: t('projects/mkmudae/try/ref'),
      href: t('projects/mkmudae/try/href'),
    },
    {
      name: t('projects/mkmudae/showcase/tag'),
      content: t('projects/mkmudae/showcase/desc'),
      ref: t('projects/mkmudae/showcase/ref'),
      href: t('projects/mkmudae/showcase/href'),
    },
  ];

  return globalBuilder.Projects(
    attributesList1,
    attributesList2,
    attributesList3,
    attributesList4,
    attributesList5,
    attributesList6,
    attributesList7,
    attributesList8,
    attributesList9,
    attributesList10,
    getTurn,
  );
};
